module.exports = __webpack_public_path__ + "static/media/at.854314b8.svg";